//Node Modules
import { useLocation } from "react-router-dom";
import ProductCard from "../components/ProductCard";

export default function Products() {
  const location = useLocation();
  const requiredData = location.state?.productData;
  const products = requiredData.products;
  const productsList = products.map((product) => (
    <ProductCard product={product} key={product} />
  ));

  return (
    <div className="products-page">
      <p>Our range of products</p>
      <section className="products"> {productsList}</section>
    </div>
  );
}
